import { render, staticRenderFns } from "./InformForm.vue?vue&type=template&id=26253d93&scoped=true&"
import script from "./InformForm.vue?vue&type=script&lang=js&"
export * from "./InformForm.vue?vue&type=script&lang=js&"
import style0 from "./InformForm.vue?vue&type=style&index=0&id=26253d93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26253d93",
  null
  
)

export default component.exports